import { type FormEvent, useEffect, useRef } from 'react';
import { Button } from '../Button';
import { Modal, type ModalProps } from '../Modal';

type FormModalProps = Omit<ModalProps, 'children'> & {
  onSubmit: (e: FormEvent) => void;
  isPending?: boolean;
  disableSubmit?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  children: React.ReactNode;
  resetForm: () => void;
};

export function FormModal(props: FormModalProps) {
  const {
    title,
    open,
    onOpenChange,
    children,
    onSubmit,
    isPending = false,
    disableSubmit = false,
    submitLabel = 'Confirmer',
    cancelLabel = 'Annuler',
    resetForm,
    ...modalProps
  } = props;

  const prevOpenRef = useRef(open);

  useEffect(() => {
    if (open && !prevOpenRef.current) {
      resetForm();
    }
    prevOpenRef.current = open;
  }, [open, resetForm]);

  return (
    <Modal title={title} open={open} onOpenChange={onOpenChange} {...modalProps}>
      {open && (
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          {children}
          <div className="flex gap-2 grow">
            <Button
              type="button"
              variant="outline"
              className="grow"
              onClick={() => onOpenChange(false)}
            >
              {cancelLabel}
            </Button>
            <Button
              type="submit"
              variant="color"
              className="bg-pink-700 grow"
              isPending={isPending}
              disabled={disableSubmit}
              onClick={(e) => {
                e.preventDefault();
                onSubmit(e);
              }}
            >
              {submitLabel}
            </Button>
          </div>
        </form>
      )}
    </Modal>
  );
}
